import { useMemo } from 'react';
import { useBooleanConditions } from '../../widgets/hooks/useBooleanConditions.tsx';
import {
  type IEngineRuntimeSection,
  type IEngineSection,
} from '../IEngineSection.ts';

/**
 * Ottiene le informazioni di visibilità e abilitazione di tutte le sezioni
 * fornite in input.
 */
export function useRuntimeEngineSections<T extends IEngineSection>(
  sections: T[],
): Array<IEngineRuntimeSection<T>> {
  // 1. Ottiene le informazioni di visibilità delle sezioni
  const allVisibles = useMemo(
    () => sections.map(s => s.ultimaVersione?.visibile),
    [sections],
  );
  const visibles = useBooleanConditions(allVisibles, { name: 'root' });

  // 2. Ottiene le informazioni di abilitazione delle sezioni
  const allEnableds = useMemo(
    () => sections.map(s => s.ultimaVersione?.compilabile),
    [sections],
  );
  const enableds = useBooleanConditions(allEnableds, { name: 'root' });

  // 3. Combina le informazioni di visibilità e abilitazione
  return useMemo(
    () =>
      sections.map((s, index) => ({
        section: s,
        visible: visibles[index].result,
        enabled: enableds[index].result,
      })),
    [sections, visibles, enableds],
  );
}
